import React from "react";
import { Images } from "../Common/Images"; // adjust path if needed
import { useTranslation } from 'react-i18next';

const AlertPopupModal = ({
  title = "Alert",
  message = "",
  onClose,
  onConfirm,
  withBackdrop = false,
}) => {
  const { t } = useTranslation("common");
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
      return;
    }

    onClose?.();
  };

  const modalContent = (
    <div className="modal fade show alertpopup d-block"
    style={{ background: "rgba(217, 217, 217, 0.59)" }}>
      <div className="modal-dialog modal-dialog-centered modal-custom-width">
        <div className="modal-content modal-radius">
          <div className="modal-body">

            {/* Close Button */}
            <div className="close-modal text-end">
              <img
                src={Images.Close}
                alt="close"
                style={{ cursor: "pointer" }}
                onClick={onClose}
              />
            </div>

            {/* Title */}
            <div className="pt-2">
              <h5 className="popup-title">{title}</h5>
            </div>

            {/* Description */}
            <div className="modal-des mt-35 text-center">
              <p>{message}</p>

              {/* Dynamic Icon */}
              <div className="modal-img text-center my-3">
                <img
                  src={Images.Alert                  }
                  className="img-fluid"
                  alt="notification-icon"
                />
              </div>

              {/* Confirm Button */}
              <button
                className="main-btn outline-alert-btn w-full"
                onClick={handleConfirm}
              >
                {t("confirm")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  if (!withBackdrop) {
    return modalContent;
  }

  return (
    <div
      className="modal"
      style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-hidden="true"
    >
      {modalContent}
    </div>
  );
};

export default AlertPopupModal;
